<template>
  <table class="table table-bordered my-3">
    <thead class="thead">
      <tr>
        <th colspan="3">{{ $t('社内工程') }}</th>
        <th>{{ $t('構成部品') }}</th>
        <th>{{ $t('数量') }}</th>
        <th>{{ $t('段取時間') }}</th>
        <th>{{ $t('加工時間') }}</th>
        <th>{{ $t('担当者') }}</th>
        <th>{{ $t('加工合計') }}</th>
        <th>{{ $t('原価') }}</th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr>
        <td class="w-5" rowspan="3">
          {{baseProcess.sort}}
        </td>
        <td class="w-10" rowspan="3">
          <template v-if="baseProcess.processKindId">
            {{ $t(mixinProcessKindDisplay(baseProcess.processKindId)) }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td class="w-10" rowspan="3">
          <template v-if="baseProcess.processId">
            {{ baseProcess.processName }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td rowspan="3" class="p-0 w-19">
          <table class="table mb-0">
            <tbody class="tbody">
              <tr v-for="(item, index) in baseProcess.structures" :key="index" class="bd-top">
                <td>{{ item.productCode }}/{{ item.productName }}</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td rowspan="3" class="p-0 w-5">
          <table class="table mb-0">
            <tbody class="tbody">
              <tr v-for="(item, index) in baseProcess.structures" :key="index" class="bd-top">
                <td>{{ item.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td class="w-9">
          <template v-if="baseProcess.prepareTime !== null">
            {{ baseProcess.prepareTime }}&nbsp;{{ mixinTimeUnitDisplay(baseProcess.timeUnit) }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td class="w-9">
          <template v-if="baseProcess.machiningTime !== null">
            {{ baseProcess.machiningTime }}&nbsp;{{ mixinTimeUnitDisplay(baseProcess.timeUnit) }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td class="w-9">
          <template v-if="baseProcess.userId">
            {{ baseProcess.userName }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td class="w-9">
          {{ totalTime }}&nbsp;{{ mixinTimeUnitDisplay(baseProcess.timeUnit) }}
        </td>
        <td rowspan="3" class="w-19">
          {{ cost | mixinCommaDisplay }}&nbsp;{{ $t('円') }}
        </td>
      </tr>
      <tr>
        <td colspan="2" class="w-18">
          <template v-if="baseProcess.jig">
            {{ baseProcess.jig }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td colspan="2" class="w-18">
          <template v-if="baseProcess.tool">
            {{ baseProcess.tool }}
          </template>
          <template v-else>
            -
          </template>
        </td>
      </tr>
      <tr>
        <td colspan="4" class="w-36 text-break">
          <template v-if="baseProcess.note">
            {{ baseProcess.note }}
          </template>
          <template v-else>
            -
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    baseProcess: {
      tupe: Object,
      default: () => {},
    },
    processes: {
      type: Array,
      default: () => [],
    },
    processKinds: {
      type: Array,
      default: () => [],
    },
    partners: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: () => [],
    },
    structures: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      structureCost: 0,
      InHouseCost: 0,
    }
  },
  methods: {
    // 工程区分のモーダルを表示
    processKindsModalOpen() {
      this.$emit('processKindsModalOpen')
    },
    // 標準工程をコピー
    copyProcess() {
      this.$emit('copyProcess')
    },
    // 標準工程を挿入
    insertProcess() {
      this.$emit('insertProcess')
    },
    // ソートを変更する処理
    changeSort(direction) {
      this.$emit('changeSort', { sort: this.baseProcess.sort, direction: direction })
    },
    // 値を変更する処理
    changeValue(e, key, type) {
      this.$emit('changeValue', { value: e.target.value, key: key, type: type })
    },
    addStructure() {
    },
    // 構成部品の合計原価を親コンポーネントのdataに足す
    addStructureCost() {
      this.$parent.structureCost += this.structureCost
    },
    // 社内工程の原価を親コンポーネントのdataに足す
    addInHouseCost() {
      this.$parent.InHouseCost += this.InHouseCost
    },
  },
  computed: {
    isHouseName() {
      return (id = null) => {
        if (!id) return []
        return this.processes.filter(item => item.processKindId === id && item.userId.includes(this.userdata.id))
      }
    },
    // 原価計算の処理
    cost() {
      if (!this.baseProcess.timeUnit) return 0
      let structureCost = 0
      this.baseProcess.structures.map(item => {
        if (item.purchasePrice && this.isNumber(item.purchasePrice)
          && item.quantity && this.isNumber(item.quantity)) {
          structureCost += (item.purchasePrice * item.quantity)
        }
      })
      // FIXME: computedの中でdataに代入すべきではない
      this.structureCost = structureCost // eslint-disable-line vue/no-side-effects-in-computed-properties
      let processCost = 0
      let chargeCost = 0
      // 計算に必要な値を定義
      const process = this.mixinIdObjectDisplay('processes', this.baseProcess.processId)
      const user = this.mixinIdObjectDisplay('users', this.baseProcess.userId)

      const prepareTime = (this.baseProcess.prepareTime && this.isNumber(this.baseProcess.prepareTime)) ? this.mixinHourFix(this.baseProcess.prepareTime, this.baseProcess.timeUnit) : 0
      const machiningTime = (this.baseProcess.machiningTime && this.isNumber(this.baseProcess.machiningTime)) ? this.mixinHourFix(this.baseProcess.machiningTime, this.baseProcess.timeUnit) : 0
      if (process && process.hourPrice && this.isNumber(process.hourPrice)) processCost = machiningTime * process.hourPrice
      const IsUser = (
        user && user.hourPrice && this.isNumber(user.hourPrice)
      )
      if (process.division === 'auto') {
        if (IsUser) chargeCost = prepareTime * user.hourPrice
      } else if (process.division === 'manual') {
        if (IsUser) chargeCost = (prepareTime + machiningTime) * user.hourPrice
      }
      // FIXME: computedの中でdataに代入すべきではない
      this.InHouseCost = (structureCost + processCost + chargeCost) // eslint-disable-line vue/no-side-effects-in-computed-properties
      return (structureCost + processCost + chargeCost)
    },
    totalTime() {
      if (this.isEmpty(this.baseProcess.prepareTime) && this.isEmpty(this.baseProcess.machiningTime)) return '-'
      if (this.isEmpty(this.baseProcess.prepareTime)) return this.baseProcess.machiningTime
      if (this.isEmpty(this.baseProcess.machiningTime)) return this.baseProcess.prepareTime
      return (this.baseProcess.prepareTime + this.baseProcess.machiningTime)
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
  watch: {
    'structureCost': function() {
      this.$emit('addStructureCost')
    },
    'InHouseCost': function() {
      this.$emit('addInHouseCost')
    },
  },
}
</script>

<style lang="scss">
.bd-top {
  td {
    border: none !important;
  }
  + .bd-top > td {
    border-top: 1px solid #dee2e6 !important;
  }
}
</style>
